import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { ListCardGroup } from 'components/list-card-group';

import { IModifierData, Modifier } from '../modifier';

import { IModifierGroupProps } from './types';

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  selectedItem,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ListCardGroup
      items={modifiers}
      header={
        displayGroupName !== 'chooseItemAmount'
          ? formatMessage({ id: displayGroupName })
          : undefined
      }
      renderItem={({ item: modifierProps }: { item: IModifierData }) => {
        return (
          <Modifier
            key={`modifier-${modifierProps.modifier.name?.locale}`}
            {...modifierProps}
            onSelectionsChange={selections =>
              onModifierSelectionChange(selections, modifierProps.modifier)
            }
            selectedItem={selectedItem}
          />
        );
      }}
    />
  );
};
